import React from "react";
import { Card, Button, Tag, Avatar } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    MailOutlined,
    PhoneOutlined,
    BellOutlined,
    UserOutlined
} from "@ant-design/icons";
import { cn } from "../../../../utils/cn";
import SOURCES from "../../../../utils/constants";

const EnhancedAlertGridView = ({
    record,
    actions = [],
    onCardClick,
}) => {
    const { ALERT_VIA_EMAIL, ALERT_VIA_SMS, ALERT_VIA_BOTH } = SOURCES;

    // Filter actions based on conditions
    const filteredActions = actions
        .map((action) => {
            if (action.condition && !action.condition(record)) {
                return null;
            }
            return action;
        })
        .filter(Boolean);

    const getAlertViaTag = () => {
        let text = record.alertVia;
        let color = "blue";
        if (record.alertVia === ALERT_VIA_BOTH) {
            text = "Email & SMS";
            color = "purple";
        } else if (record.alertVia === ALERT_VIA_SMS) {
            color = "green";
        }
        return <Tag color={color} className="capitalize">{text}</Tag>;
    };

    return (
        <Card
            hoverable
            className="h-full cursor-pointer"
            onClick={onCardClick}
        >
            <div className="space-y-4">
                {/* Alert Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 w-full">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={<BellOutlined />}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate text-primary capitalize">
                                {record.alertName || "N/A"}
                            </h3>
                            {getAlertViaTag()}
                        </div>
                    </div>
                </div>

                {/* Alert Info */}
                <div className="space-y-2">
                    {/* Email */}
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate">
                            Email: <span className="text-gray-800 font-medium">{record.alertEmail}</span>
                        </span>
                    </div>

                    {/* Mobile */}
                    <div className="flex items-center text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate">
                            Mobile: <span className="text-gray-800 font-medium">{record.alertSms || 'N/A'}</span>
                        </span>
                    </div>
                </div>

                {/* Action Buttons */}
                {filteredActions.length > 0 && (
                    <div
                        className={cn(
                            "grid gap-2 pt-3 border-t border-gray-200",
                            filteredActions.length === 1 ? "grid-cols-1" : "grid-cols-2"
                        )}
                    >
                        {filteredActions.map((action, idx) => (
                            <Button
                                key={idx}
                                title={action.title ?? action.label}
                                className={cn(
                                    "text-sm font-medium h-9 my-1 !border-primary !text-primary hover:!bg-primary hover:!text-white !min-w-full flex justify-center items-center transition-colors duration-150 ease-in-out",
                                    action.className
                                )}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick(record);
                                }}
                            >
                                {action.icon &&
                                    React.cloneElement(action.icon, { className: "mr-2" })}
                                {action.label}
                            </Button>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default EnhancedAlertGridView;
